type XRayConfigurationEvent =
  | 'viewContent'
  | 'viewItem'
  | 'search'
  | 'addToCart'
  | 'initiateCheckout'
  | 'addPaymentInfo'
  | 'purchase'
  | 'subscriptionPurchase'
  | 'completeRegistration'
  | 'subscribe';

export const XRAY_CONFIGURATION_DEFAULT_EVENTS = {
  viewContent: 'viewContent',
  viewItem: 'viewItem',
  search: 'search',
  addToCart: 'addToCart',
  initiateCheckout: 'initiateCheckout',
  addPaymentInfo: 'addPaymentInfo',
  purchase: 'purchase',
  subscriptionPurchase: 'subscriptionPurchase',
  completeRegistration: 'completeRegistration',
  subscribe: 'subscribe',
};

export interface XrayConfigurationPayload {
  botId: number | string;
  promoterId: number | string;
  facebookPageId: number;
  createdAt?: string | null;
  updatedAt?: string | null;
  configurations: Record<XRayConfigurationEvent | string, string>;
  eventsCounts: Record<XRayConfigurationEvent | string, number>;
  pixelId: string | null;
  accessToken: string | null;
  active: boolean;
  facebookErrors?: {
    id: number;
    date: string;
    severity: string;
    details?: { number: number; message: string };
    errorType?: string;
    originalMessage?: string;
    code: string;
    subCode: string;
    updatedAt: string;
  }[];
}

export interface XrayConfigurationState {
  busy?: boolean;
  entities?: XrayConfigurationPayload[];
}
